/*
 * Set of utility functions
 *
 */
import * as qs from "query-string";

// convert bytes into a human readable string
// Examples:
//  1024 bytes => 1 kB
//  67528 bytes => 65.95 kB
export const readableSize = (size: number) => {
  if (isNaN(size) || size < 0) return 0;
  const i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
  return (
    Number((size / Math.pow(1024, i)).toFixed(2)) +
    " " +
    ["B", "kB", "MB", "GB", "TB"][i]
  );
};

export const stringOrEmpty = (value: any): string => {
  if (typeof value === "string") return value;
  return "";
};

export const stringOrUndefined = (value: any): string | undefined => {
  if (typeof value === "string") return value;
  return undefined;
};

export function mapAsync<T, U>(
  array: T[],
  callbackfn: (value: T, index: number, array: T[]) => Promise<U>
): Promise<U[]> {
  return Promise.all(array.map(callbackfn));
}

export async function filterAsync<T>(
  array: T[],
  callbackfn: (value: T, index: number, array: T[]) => Promise<boolean>
): Promise<T[]> {
  const filterMap = await mapAsync(array, callbackfn);
  return array.filter((value, index) => filterMap[index]);
}

// helper to parse a query string
// returns value for key (string only) or defValue, if key doesn't exist or is not a string
export const parseQuery = (
  query: string,
  key: string,
  defValue: string = ""
): string => {
  const params = qs.parse(query);
  if (!params || !(key in params)) return defValue;
  const value = params[key];
  if (value === undefined || value === null || typeof value !== "string")
    return defValue;
  return value;
};
